"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVUtil = void 0;
const jsonexport = require('jsonexport/dist');
const fileDownload = require('js-file-download');
const lodash_1 = __importDefault(require("lodash"));
exports.CSVUtil = {
    prepareAndDownload: (dataSource, exportOptions, parameters) => {
        (async () => {
            try {
                const fileName = lodash_1.default.compact([parameters === null || parameters === void 0 ? void 0 : parameters.identifier, lodash_1.default.kebabCase(parameters === null || parameters === void 0 ? void 0 : parameters.title), lodash_1.default.kebabCase(parameters === null || parameters === void 0 ? void 0 : parameters.subtitle)]).join("_");
                const csv = await jsonexport(dataSource, exportOptions || {});
                fileDownload(csv, `${fileName}_${new Date().getTime()}.csv`);
            }
            catch (err) {
                console.error(err);
            }
        })();
    },
};
